"use strict";

exports.registerServiceWorker = function () {
  return true;
};

var swNotInstalled = true;
var prefetchedPathnames = [];

exports.onPostPrefetchPathname = function (_ref) {
  var pathname = _ref.pathname;

  // if SW is not installed, we need to record any prefetches
  // that happen so we can then add them to SW cache once installed
  if (swNotInstalled && "serviceWorker" in navigator) {
    prefetchedPathnames.push(pathname);
  }
};

exports.onServiceWorkerActive = function (_ref2) {
  var getResourceURLsForPathname = _ref2.getResourceURLsForPathname,
      serviceWorker = _ref2.serviceWorker;
  // stop recording prefetch events
  swNotInstalled = false; // grab nodes from head of document

  var nodes = document.querySelectorAll("\n    head > script[src],\n    head > link[href],\n    head > style[data-href]\n  "); // get all resource URLs

  var headerResources = [].slice.call(nodes).map(function (node) {
    return node.src || node.href || node.getAttribute("data-href");
  }); // Loop over all resources and fetch the page component and JSON
  // to add it to the sw cache.

  var prefetchedResources = [];
  prefetchedPathnames.forEach(function (path) {
    return getResourceURLsForPathname(path).forEach(function (resource) {
      return prefetchedResources.push(resource);
    });
  });
  var resources = headerResources.concat(prefetchedResources);
  resources.forEach(function (resource) {
    // Create a prefetch link for each resource, so Workbox runtime-caches them
    var link = document.createElement("link");
    link.rel = "prefetch";
    link.href = resource;
    link.onload = link.remove;
    link.onerror = link.remove;
    document.head.appendChild(link);
  });
};